import { render } from "./AutogestionarTurnoForm.vue?vue&type=template&id=28e1162b&scoped=true"
import script from "./AutogestionarTurnoForm.vue?vue&type=script&lang=js"
export * from "./AutogestionarTurnoForm.vue?vue&type=script&lang=js"

import "./AutogestionarTurnoForm.vue?vue&type=style&index=0&id=28e1162b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28e1162b"]])

export default __exports__